// src/views/dashboard/common/Timeline.jsx
import React from "react";
import { Col, Row, Card } from "react-bootstrap";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

/**
 * Timeline component renders a list of events as a timeline.
 * Props:
 * - events: Array of { date: string, title: string, description: string, status?: 'pending'|'success'|'primary'|'warning', participants?: [{ initials: string }] }
 */
const Timeline = ({ events }) => {
  return (
    <Row>
      <Col lg="12">
        <Card>
          <Card.Body>
            <div className="iq-timeline m-0 d-flex align-items-center justify-content-between position-relative">
              <ul className="list-inline p-0 m-0 w-100">
                {events.map((evt, idx) => (
                  <li
                    key={idx}
                    className={
                      evt.status === "success" ? "bg-success bg-opacity-10" : ""
                    }
                  >
                    <div
                      className={`time ${
                        evt.status === "success" ? "bg-success text-white" : ""
                      }`}
                    >
                      <span>{evt.date}</span>
                    </div>
                    <div className="content">
                      <div
                        className={`timeline-dots new-timeline-dots border-${
                          evt.status || "primary"
                        }`}
                      ></div>
                      <h6 className="mb-1">{evt.title}</h6>
                      <div className="d-inline-block w-100">
                        <p>{evt.description}</p>
                        {evt.participants && (
                          <div className="iq-media-group iq-media-group-1">
                            {evt.participants.map((p, i) => (
                              <Link to="#" key={i} className="iq-media-1">
                                <div className="icon iq-icon-box-3 rounded-pill">
                                  {p.initials}
                                </div>
                              </Link>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

Timeline.propTypes = {
  events: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string,
      status: PropTypes.oneOf(["pending", "success", "primary", "warning"]),
      participants: PropTypes.arrayOf(
        PropTypes.shape({ initials: PropTypes.string.isRequired })
      ),
    })
  ).isRequired,
};

export default Timeline;
